<div class="detail-view">
    <div>
        <ng-container *ngIf="course$ | async as course; else loader">
            <section class="background-color-nearwhite">
                <div class="course container" *ngIf="course">
                    <da-course-teaser [showBookingBtn]="true" [showDemoBtn]="true" [course]="course"></da-course-teaser>
                </div>
            </section>
            <section *ngIf="isPlusPortSite && course.training.description">
                <div class="container">
                    <div class="plus-port-description-long" [innerHTML]="decodeHtml(course.training.description)"></div>
                </div>
            </section>
            <section class="background-color-white container">
                <div class="content course-details">
                    <div class="left">
                        <da-tab-section [data]="course"></da-tab-section>
                    </div>
                </div>
                <a *ngIf="description && (showDownload$ | async) && (site === 'de_de' || isPortal)" (click)="printPDFCourse()" class="download"
                    ><span class="drg-icon-download"></span><span class="download-label" [innerHTML]="'courses.courseDescriptionDownload.downloadLinkLabel' | translate"></span
                ></a></section
        ></ng-container>
    </div>
    <ng-container *ngIf="similarCourse$ | async as similarCourse">
        <ng-container *ngIf="showSimilarCourses$ | async">
            <da-similar-courses *ngIf="similarCourse && similarCourse.length > 0" [similarCourses]="similarCourse"></da-similar-courses>
        </ng-container>
    </ng-container>

    <ng-template #loader>
        <section>
            <div id="loader-screen" class="drg-loading-container">
                <i class="loading-icon"></i>
                <i class="loader-shadow"></i>
            </div>
        </section>
    </ng-template>

    <ng-template #warningWishlist>
        <div class="embedcontainer">
            <ng-container *ngTemplateOutlet="warnWishlist"></ng-container>
        </div>
    </ng-template>
    <ng-template #warnWishlist>
        <div class="modal">
            <div class="popup-warning">
                <div class="details">
                    <h3 [innerHTML]="'addToShopingCart.courseAlreadyInWishlistTitle' | translate"></h3>
                    <p [innerHTML]="'addToShopingCart.courseAlreadyInWishlistText' | translate"></p>
                    <div class="button-container">
                        <div class="button-wrapper">
                            <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                            <a class="button primary" da-link (click)="goToCart()" [innerHTML]="'courses.showCart' | translate"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <div class="notification" *ngIf="showCartUpdate$ | async as showCartUpdate">
        <div class="modal" *ngIf="course$ | async as course">
            <div class="location-popup" [ngClass]="showCartUpdate ? 'fade' : ''">
                <div class="title">
                    <span class="checked"></span>
                    <span [innerHTML]="'courses.update' | translate"></span>
                </div>
                <div class="inner-wrapper">
                    <div class="details">
                        <span>{{ course.name }}</span>
                        <span *ngIf="course.price !== undefined && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                            {{formattedPrice$ | async}}
                            <span [innerHTML]="'booking.bookingParticipants.symbol' | translate"></span>
                        </span>

                        <div class="price" *ngIf="course.metadata && !course.metadata.showPrice">
                            <span [innerHTML]="'courses.noPrice' | translate"></span>
                        </div>
                    </div>
                    <div class="type">{{ course.type }}</div>
                    <a (click)="goToCart()" class="button secondary" [innerHTML]="'courses.showCart' | translate"></a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="pdf-wrapper">
    <div #pdfCourse id="pdfCourse" *ngIf="course$ | async as course">
        <ng-container>
            <section>
                <div *ngIf="course">
                        <div class="logo-container one-column container-box">
                            <img [src]="logo"/>
                        </div>
                        <div class="two-column-right container-box learning-and-image">
                            <div class="leftcolumn">
                                <div class="title">
                                    <strong>{{ course.name }}</strong>
                                </div>
                                <p *ngIf="course.training.subTitle" class ="subtitle">{{course.training.subTitle}}</p>
                            </div>
                            <div class="rightcolumn">
                                <div class="media" *ngIf="courseImage$ | async as courseImage">
                                    <img [src]="courseImage" />
                                </div>
                            </div>
                        </div>
                        <div *ngIf="site === 'de_de' && !isPortal && course.training.descriptionShort" class="grey-box short-description">
                            <p>{{course.training.descriptionShort}}</p>
                        </div>
                        <div *ngIf="isPortal && learningGoalsText" class="grey-box short-description">
                            <ng-container *ngFor="let goal of learningGoalsText">
                                <p>{{goal.text}}</p>
                                <ul *ngIf="goal.subTexts !== null">
                                    <li *ngFor="let subtext of goal.subTexts">{{subtext}}</li>
                                </ul>
                            </ng-container>
                        </div>
                        <div class="two-column-right container-box">
                            <div class="leftcolumn">
                                <div class="short-infos">
                                    <div *ngIf="events && events.length > 0">
                                        <div class="subtitle-blue" [innerHTML]="'event.duration' | translate"></div>
                                        <p>{{ eventDuration}} <span *ngIf="eventDuration === 1" [innerHTML]="'event.day' | translate"></span><span *ngIf="eventDuration > 1" [innerHTML]="'event.days' | translate"></span>, {{course.events[0].beginDateTime | date: 'HH:mm'}} <span></span> - {{course.events[0].endDateTime | date: 'HH:mm'}} <span></span></p>
                                    </div>
                                    <div>
                                        <div class="subtitle-blue" [innerHTML]="'courses.courseDescriptionDownload.numbersOfParticipants' | translate"></div>
                                        <p>
                                            <span [innerHTML]="'courses.courseDescriptionDownload.maximum' | translate"></span> {{course.slotsMax}} <span [innerHTML]="'courses.courseDescriptionDownload.persons' | translate"></span>
                                        </p>
                                    </div>
                                    <div>
                                        <div class="subtitle-blue" [innerHTML]="'courses.courseDescriptionDownload.price' | translate" ></div>
                                        <div class="price" *ngIf="course.prices.length > 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                                            <span *ngIf="course.prices.length === 1 || course.prices.length > 1 && course.prices[1].value === course.prices[0].value"> {{formattedPrice$ | async}}</span>
                                            <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value > 0">{{formattedPrice$ | async}} - {{formattedPrice2$ | async}}</span>
                                            <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value === 0">{{formattedPrice2$ | async}}</span>
                                            &nbsp;<span [innerHTML]="'courses.courseDescriptionDownload.plusVATPerPerson' | translate"></span>
                                            <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
                                        </div>
                                        <div class="price" *ngIf="course.price !== undefined && course.prices.length === 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                                            <span> {{formattedPrice$ | async}}</span>
                                            <span [innerHTML]="'courses.courseDescriptionDownload.plusVATPerPerson' | translate"></span>
                                            <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
                                        </div>
                                        <div class="price" *ngIf="course.metadata && !course.metadata.showPrice">
                                            <span [innerHTML]="'courses.noPrice' | translate"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="rightcolumn">
                                <div class="qr-code-wrapper">
                                   <div class="qr-code-image">
                                      <qrcode [qrdata]="courseUrl" [width]="70"></qrcode>
                                    </div>
                                    <div class="label-box">
                                        <span class="label" [innerHTML]="'courses.courseDescriptionDownload.bookADate' | translate"></span>
                                        <span class="url">{{courseUrlPrint}}</span>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </section>
            <section class="more-details-box">
                <div *ngIf="targetGroupText">
                    <div class="subtitle-blue">{{targetGroupTitle}}</div>
                    <div *ngFor="let paragraph of targetGroupText">
                        <p>{{paragraph.text}}</p>
                        <ul *ngIf="paragraph.subTexts !== null">
                            <li *ngFor="let subtext of paragraph.subTexts">{{subtext}}</li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="requirementsText">
                    <div class="subtitle-blue">{{requirementsTitle}}</div>
                    <div *ngFor="let paragraph of requirementsText">
                        <p>{{paragraph.text}}</p>
                        <ul *ngIf="paragraph.subTexts !== null">
                            <li *ngFor="let subtext of paragraph.subTexts">{{subtext}}</li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="courseContentText && courseContentText">
                    <div class="subtitle-blue">{{courseContentTitle}}</div>
                    <div *ngFor="let contentParagraph of courseContentText">
                        <p>{{contentParagraph.text}}</p>
                        <ul *ngIf="contentParagraph.subTexts !== null && contentParagraph.subTexts.length <= 5">
                            <li *ngFor="let subtext of contentParagraph.subTexts">{{subtext}}</li>
                        </ul>
                        <div *ngIf="contentParagraph.subTexts !== null && contentParagraph.subTexts.length > 5">
                            <div class="two-column-center">
                                <div class="leftcolumn border">
                                    <ul>
                                        <li *ngFor="let subtext of contentParagraph.subTexts | slice:0:contentParagraph.subTexts.length/2">{{subtext}}</li>
                                    </ul>
                                </div>
                                <div class="rightcolumn">
                                    <ul>
                                        <li *ngFor="let subtext of contentParagraph.subTexts | slice:contentParagraph.subTexts.length/2:contentParagraph.subTexts.length">{{subtext}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="note-section">
                <div *ngIf="noteText" class="grey-box">
                    <p class="headline-small">{{noteTextTitle}}</p>
                    <div *ngFor="let paragraph of noteText">
                        <p>{{paragraph.text}}</p>
                        <ul *ngIf="paragraph.subTexts !== null">
                            <li *ngFor="let subtext of paragraph.subTexts">{{subtext}}</li>
                        </ul>
                    </div>
                </div>
            </section>
            <section *ngIf="events && events.length > 0" class="location-section">
                <ng-container *ngIf="site === 'de_de' && !isPortal">
                    <div class="subtitle-blue location">Standorte</div>
                    <div class="four-column container-box">
                        <div *ngIf="eventsNorth && eventsNorth.length > 0" class="column">
                            <div class="subtitle-blue">NORD</div>
                            <div *ngFor="let city of citiesNorth">
                                <div class="events-in-city">
                                    <span>{{city}}</span>
                                    <div *ngFor="let event of eventsNorth">
                                        <div *ngIf="event.location.city === city">
                                            <p *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}} - {{ event.endDateTime | date: (dateFormat$ | async)}}
                                            </p>
                                            <p *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        <div *ngIf="eventsEast && eventsEast.length > 0" class="column">
                            <div class="subtitle-blue">OST</div>
                            <div *ngFor="let city of citiesEast">
                                <div class="events-in-city">
                                    <span>{{city}}</span>
                                    <div *ngFor="let event of eventsEast">
                                        <div *ngIf="event.location.city === city">
                                            <p *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}} - {{ event.endDateTime | date: (dateFormat$ | async)}}
                                            </p>
                                            <p *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="eventsSouth && eventsSouth.length > 0" class="column">
                            <div class="subtitle-blue">SÜD</div>
                            <div *ngFor="let city of citiesSouth">
                                <div class="events-in-city">
                                    <span>{{city}}</span>
                                    <div *ngFor="let event of eventsSouth">
                                        <div *ngIf="event.location.city === city">
                                            <p *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}} - {{ event.endDateTime | date: (dateFormat$ | async)}}
                                            </p>
                                            <p *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="eventsWest && eventsWest.length > 0" class="column">
                            <div class="subtitle-blue">WEST</div>
                            <div *ngFor="let city of citiesWest">
                                <div class="events-in-city">
                                    <span>{{city}}</span>
                                    <div *ngFor="let event of eventsWest">
                                        <div *ngIf="event.location.city === city">
                                            <p *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}} - {{ event.endDateTime | date: (dateFormat$ | async)}}
                                            </p>
                                            <p *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <section *ngIf="isPortal && events && events.length > 0">
                    <div class="event-container">
                        <div class="subtitle-blue" [innerHTML]="'courses.courseDescriptionDownload.dates' | translate"></div>
                        <div *ngIf="events && events.length <= 5">
                            <ul>
                                <li *ngFor="let event of events">
                                    <span *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}} - {{ event.endDateTime | date: (dateFormat$ | async)}}
                                    </span>
                                    <span *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}}
                                    </span>
                                    <span>  -  </span>
                                    <span>{{ event.location.city }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="two-column-center">
                            <div *ngIf="events && events.length > 5" class="leftcolumn" [ngClass]="{'border': events.length > 5}">
                                <ul>
                                    <li *ngFor="let event of events | slice:0:eventNumber/2+1">
                                        <span *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}} - {{ event.endDateTime | date: (dateFormat$ | async)}}
                                        </span>
                                        <span *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}}
                                        </span>
                                        <span>  -  </span>
                                        <span>{{ event.location.city }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="rightcolumn">
                                <div *ngIf="events && events.length > 5" class="leftcolumn">
                                    <ul>
                                        <li *ngFor="let event of events | slice:eventNumber/2+1:eventNumber">
                                            <span *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}} - {{ event.endDateTime | date: (dateFormat$ | async)}}
                                            </span>
                                            <span *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: (dateFormat$ | async)}}
                                            </span>
                                            <span>  -  </span>
                                            <span>{{ event.location.city }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </ng-container>
    </div>
</div>
